const routes = [
    {
        path: "/installment/dates",
        component: () => import("../pages/Index"),
        meta:{
            isAuthenticated: true,
            permission:"installmentdate_index"
        }
    }
]

export default routes;
